import { uuid } from '@10000/common'
import { useRequest, useView } from '@10000/react'
import { useBackground, useShell, WelcomeScreen } from '../layout'
import { Body } from '../widgets'

export const Kiosk = ({ active }) => {
  const request = useRequest('tenant')
  const { teams } = useView('tenant')

  useShell({ active, footer: true })
  useBackground().set({ active, background: undefined })

  const start = solo => async () => {
    const id = uuid()
    await request('squizCreated', {
      id,
      teamId: teams[0].id,
      options: {
        kiosk: true,
        solo,
        presenterParticipates: false,
        tutorial: true,
        consensus: !solo,
        questionCount: solo ? 6 : 3
      }
    })
  }

  return (
    <WelcomeScreen
      title={<Body alt bold size={80}>Welcome to Shivoo <img src={`https://fonts.gstatic.com/s/e/notoemoji/latest/1f44b/512.gif`} width={80} height={80} /></Body>}
      titleSize={55}
      description="Select the mode you would like to play in"
      descriptionSize={24}
      firstCardTitle={<>Solo&nbsp;Mode</>}
      firstCardDescription="I am answering by myself."
      firstCardClicked={start(true)}
      secondCardTitle={<>Team&nbsp;Mode</>}
      secondCardDescription="I have a group of colleagues, we will answer together."
      secondCardClicked={start(false)}
    />
  )
}